// Container.js
import React, { useContext } from "react";
import { FilterContext } from "../../context/Filter";

const Container = ({ title, children }) => {
  const { open } = useContext(FilterContext); // ✅ move inside function body

  return (
    <div>
      <div className={`bg-white shadow-md rounded-lg w-96 md:w-full md:${open ? 'w-[335px]' : 'w-96'} border-2  border-gray-300 md:p-5 min-h-full h-full`}>
        <h2 className="text-xl font-bold">{title}</h2>
        <div className="space-y-2">{children}</div>
      </div>
    </div>
  );
};

export default Container;
